import React, { useEffect, useState, useRef } from "react";
import "./../Styles/Beads.css";
import { API } from "../../config/api";

import { useParams } from "react-router-dom";
import VerticalAds from "../../Admin/Pages/VerticleAds";
import HorizontalAds from "../../Admin/Pages/HorizontalAds";
export default function Supplier() {
  const [records, setRecords] = useState([]);
  const [filteredRecords, setFilteredRecords] = useState([]);
  const [selectedImages, setSelectedImages] = useState({});

  // Advanced Sidebar Filtering States
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedCity, setSelectedCity] = useState("");
  const [selectedSkills, setSelectedSkills] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(20);
  const thumbnailRefs = useRef({});
  const [loading, setLoading] = useState(true);
  const [supplierTypes, setSupplierTypes] = useState([]);
  const { type } = useParams();
  const [popupData, setPopupData] = useState({
    open: false,
    images: [],
    index: 0,
    userId: null,
    supplierTable: "",
  });
  const openImagePopup = (recordId, img, userId, images, supplierTable) => {
    const index = images.findIndex((i) => i === img);

    setPopupData({
      open: true,
      images,
      index: index >= 0 ? index : 0,
      userId,
      supplierTable,
    });
  };
  const fetchSupplierTypes = async () => {
    try {
      const res = await fetch(`${API.BASE_URL}/api.php?action=supplier_types`);

      const data = await res.json();

      if (data.status) {
        setSupplierTypes(data.data);
      }
    } catch (err) {
      console.log(err);
    }
  };
  useEffect(() => {
    Object.keys(selectedImages).forEach((id) => {
      const img = selectedImages[id];
      const container = thumbnailRefs.current[id];

      if (!container || !img) return;

      const index = Array.from(container.children).findIndex((el) =>
        el.getAttribute("src")?.includes(img),
      );

      if (index >= 0 && container.children[index]) {
        container.children[index].scrollIntoView({
          behavior: "smooth",
          inline: "center",
          block: "nearest",
        });
      }
    });
  }, [selectedImages]);
  useEffect(() => {
    if (!popupData.open) return;

    const handleKeyDown = (e) => {
      if (e.key === "ArrowRight") {
        setPopupData((prev) => ({
          ...prev,
          index:
            prev.index < prev.images.length - 1 ? prev.index + 1 : prev.index,
        }));
      }

      if (e.key === "ArrowLeft") {
        setPopupData((prev) => ({
          ...prev,
          index: prev.index > 0 ? prev.index - 1 : prev.index,
        }));
      }

      if (e.key === "Escape") {
        setPopupData((prev) => ({ ...prev, open: false }));
      }
    };

    window.addEventListener("keydown", handleKeyDown);

    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [popupData.open]);
  const [selectedTypes, setSelectedTypes] = useState([]);

  const fetchSuppliers = async () => {
    try {
      setLoading(true);

      const res = await fetch(`${API.BASE_URL}/api.php?action=all_suppliers`);

      const data = await res.json();

      if (data.status) {
        const suppliers = (data.data || []).map((item) => ({
          ...item,
          images: Array.isArray(item.images)
            ? item.images
            : item.images
              ? item.images.split(",").filter((img) => img.trim() !== "")
              : [],
        }));

        setRecords(suppliers);
        setFilteredRecords(suppliers);
      } else {
        setRecords([]);
        setFilteredRecords([]);
      }
    } catch (err) {
      console.log("Supplier fetch error:", err);
      setRecords([]);
      setFilteredRecords([]);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchSuppliers();
    fetchSupplierTypes();
  }, []);
  useEffect(() => {
    setCurrentPage(1);
  }, [
    searchTerm,
    selectedCity,
    selectedSkills,
    records,
    selectedTypes,
    itemsPerPage,
  ]);

  useEffect(() => {
    const filtered = records.filter((item) => {
      const matchSearch =
        searchTerm === "" ||
        item.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        item.mobile?.includes(searchTerm) ||
        item.address?.toLowerCase().includes(searchTerm.toLowerCase());

      const matchCity =
        selectedCity === "" ||
        item.address?.toLowerCase().includes(selectedCity.toLowerCase());

      const matchType =
        selectedTypes.length === 0 ||
        selectedTypes.includes(item.supplier_table);

      return matchSearch && matchCity && matchType;
    });

    setFilteredRecords(filtered);
  }, [searchTerm, selectedCity, selectedTypes, records]);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;

  const currentRecords = filteredRecords.slice(
    indexOfFirstItem,
    indexOfLastItem,
  );

  const totalPages = Math.ceil(filteredRecords.length / itemsPerPage);

  const paginate = (page) => {
    setCurrentPage(page);
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  /* =========================================================
      3. MAP UTILITY REDIRECT
     ========================================================= */
  const handleLocationRedirect = (address) => {
    if (!address) return;
    const mapUrl = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(address)}`;
    window.open(mapUrl, "_blank", "noopener,noreferrer");
  };

  if (loading) {
    return (
      <div className="supplier-loading-container">
        <div className="supplier-loader">
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>

          <h5 className="mt-3 mb-1">Loading Suppliers...</h5>

          <p className="text-muted mb-0">
            Please wait while we fetch the latest supplier details.
          </p>
        </div>
      </div>
    );
  }
  const handleTypeChange = (type) => {
    if (selectedTypes.includes(type)) {
      setSelectedTypes(selectedTypes.filter((t) => t !== type));
    } else {
      setSelectedTypes([...selectedTypes, type]);
    }
  };

  return (
    <div className="shop-page container-fluid py-4">
      <div className="row">
        {/* ==========================================================================
            LEFT FILTER SIDEBAR (Desktop)
           ========================================================================== */}
        <div className="col-lg-2 d-none d-lg-block" data-aos="fade-right">
          <div
            className="filter-sidebar shadow-sm p-3 bg-white rounded sticky-top"
            style={{ top: "20px" }}
          >
            {/* <div className="d-flex justify-content-between align-items-center mb-3">
              <h5 className="mb-0">Filters</h5>
              <button
                className="btn btn-sm text-danger p-0"
                onClick={() => {
                  setSearchTerm("");
                  setSelectedCity("");
                  setSelectedSkills([]);
                  setSelectedTypes([]);
                }}
                style={{ fontSize: "0.8rem", fontWeight: "600" }}
              >
                CLEAR ALL
              </button>
            </div> */}
            <div className="d-flex justify-content-between align-items-center mb-4 filter-header-border">
              <h5 className="mb-0 fw-bold text-secondary text-uppercase tracking-wider fs-6">
                Filters
              </h5>
              <button
                className="btn-uniq-reset"
                onClick={() => {
                  setSearchTerm("");
                  setSelectedCity("");
                  setSelectedSkills([]);
                  setSelectedTypes([]);
                }}
              >
                Clear All
              </button>
            </div>
            <div className="filter-box mb-4">
              <h6>Supplier Type</h6>

              <label className="d-block mb-2 fw-bold">
                <input
                  type="checkbox"
                  className="me-2"
                  checked={selectedTypes.length === 0}
                  onChange={() => setSelectedTypes([])}
                />
                All
              </label>

              {supplierTypes.map((item) => (
                <label key={item.id} className="d-block mb-2">
                  <input
                    type="checkbox"
                    className="me-2"
                    checked={selectedTypes.includes(item.type)}
                    onChange={() => handleTypeChange(item.type)}
                  />
                  {item.display_name}
                </label>
              ))}
            </div>

            {/* Search Input Filter */}
            <div className="filter-box mb-4">
              <h6>Keyword Search</h6>
              <input
                type="text"
                placeholder="Search name, phone..."
                className="form-control form-control-sm"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>

            {/* Design Type Category Filters */}
            {/* <div className="filter-box mb-4">
              <h6>Design Varieties</h6>
              {["Beads", "Sequin", "Malti"].map((type) => (
                <label key={type} className="d-block mb-1 core-filter-label">
                  <input
                    type="checkbox"
                    className="me-2"
                    checked={selectedSkills.includes(type)}
                    onChange={() => handleSkillChange(type)}
                  />{" "}
                  {type} Design
                </label>
              ))}
            </div> */}

            {/* City Field Filter */}
            <div className="filter-box mb-4">
              <h6>City / Hub</h6>
              <input
                type="text"
                placeholder="Search City Address"
                className="form-control form-control-sm"
                value={selectedCity}
                onChange={(e) => setSelectedCity(e.target.value)}
              />
            </div>

            <div className="sidebar-ad">
              <div className="small text-center fw-bold p-1">SPONSORED</div>

              <VerticalAds />
            </div>
          </div>
        </div>

        {/* ==========================================================================
            CENTER CONTENT AREA (Cards Grid Grid)
           ========================================================================== */}
        <div className="col-lg-10">
          <div
            className="d-flex justify-content-between align-items-center mb-4 flex-wrap gap-2"
            data-aos="fade-down"
          >
            <div>
              <h2
                className="section-title mb-0"
                style={{ color: "#00334e", fontWeight: "700" }}
              >
                {selectedTypes.length === 0
                  ? "All Suppliers"
                  : `${selectedTypes
                      .map((type) => {
                        const supplier = supplierTypes.find(
                          (s) => s.type === type,
                        );
                        return supplier ? supplier.display_name : type;
                      })
                      .join(", ")} Suppliers`}
              </h2>
            </div>
            {/* <div className="badge bg-light text-dark p-2 border shadow-sm">
              Total Active: {filteredRecords.length}
            </div> */}
            <div className="ms-auto d-flex align-items-center gap-2">
              <span className="small text-muted">Show:</span>

              <select
                className="form-select form-select-sm"
                style={{ width: "90px" }}
                value={itemsPerPage}
                onChange={(e) => {
                  setItemsPerPage(Number(e.target.value));
                }}
              >
                <option value={20}>20</option>
                <option value={40}>40</option>
                <option value={60}>60</option>
                <option value={100}>100</option>
              </select>
            </div>
          </div>

          {/* Mobile Filter Chips (Visible only on smaller breakpoints) */}
          <div className="d-lg-none mb-3 mobile-filter-bar">
            {/* {["Beads", "Sequin", "Malti"].map((type) => (
              <button
                key={type}
                className={`filter-chip ${selectedSkills.includes(type) ? "active" : ""}`}
                onClick={() => handleSkillChange(type)}
              >
                {type}
              </button>
            ))}
            <button
              className="filter-chip clear"
              onClick={() => {
                setSearchTerm("");
                setSelectedCity("");
                setSelectedSkills([]);
              }}
            >
              Clear
            </button> */}
          </div>

          {filteredRecords.length === 0 ? (
            <div className="text-center w-100 py-5 bg-white rounded shadow-sm border">
              <p className="text-muted m-0">
                No Active Records Found matching criteria
              </p>
            </div>
          ) : (
            <>
              <div className="designs-grid">
                {currentRecords.map((item, index) => (
                  <div
                    className="design-card"
                    key={item.id}
                    data-aos="zoom-in-up"
                    data-aos-delay={(index % 8) * 70}
                  >
                    <div className="machine-img-container position-relative">
                      {/* <img
                        src={
                          selectedImages[item.id]
                            ? `${API.BASE_URL}/uploads/beads/user_${item.user_id}/${selectedImages[item.id]}`
                            : item.images?.[0]
                              ? `${API.BASE_URL}/uploads/beads/user_${item.user_id}/${item.images[0]}`
                              : "https://via.placeholder.com/400"
                        }
                        className="designer-img"
                        alt={item.name}
                      /> */}
                      <img
                        src={
                          selectedImages[item.id]
                            ? `${API.BASE_URL}/uploads/${item.supplier_table}/${item.user_id}/${selectedImages[item.id]}`
                            : item.images?.[0]
                              ? `${API.BASE_URL}/uploads/${item.supplier_table}/${item.user_id}/${item.images[0]}`
                              : "https://via.placeholder.com/400"
                        }
                        className="designer-img"
                        alt={item.name}
                        onClick={() =>
                          openImagePopup(
                            item.id,
                            selectedImages[item.id] || item.images?.[0],
                            item.user_id,
                            item.images,
                            item.supplier_table,
                          )
                        }
                        style={{ cursor: "pointer" }}
                      />

                      {/* LEFT BUTTON */}
                      {item.images?.length > 1 && (
                        <button
                          className="supNavArrow supNavArrowLeft"
                          onClick={() => {
                            const current = selectedImages[item.id]
                              ? item.images.indexOf(selectedImages[item.id])
                              : 0;

                            const prevIndex =
                              current > 0
                                ? current - 1
                                : item.images.length - 1;

                            setSelectedImages((prev) => ({
                              ...prev,
                              [item.id]: item.images[prevIndex],
                            }));
                          }}
                        >
                          <i className="bi bi-chevron-left"></i>
                        </button>
                      )}

                      {/* RIGHT BUTTON */}
                      {item.images?.length > 1 && (
                        <button
                          className="supNavArrow supNavArrowRight"
                          onClick={() => {
                            const current = selectedImages[item.id]
                              ? item.images.indexOf(selectedImages[item.id])
                              : 0;

                            const nextIndex =
                              current < item.images.length - 1
                                ? current + 1
                                : 0;

                            setSelectedImages((prev) => ({
                              ...prev,
                              [item.id]: item.images[nextIndex],
                            }));
                          }}
                        >
                          <i className="bi bi-chevron-right"></i>
                        </button>
                      )}

                      {/* IMAGE COUNT */}
                      {item.images?.length > 1 && (
                        <div className="image-count">
                          <i className="bi bi-images me-1"></i>+
                          {item.images.length - 1}
                        </div>
                      )}
                    </div>

                    {item.images?.length > 0 && (
                      <div
                        className="thumbnail-tray"
                        ref={(el) => (thumbnailRefs.current[item.id] = el)}
                      >
                        {item.images.map((img, i) => (
                          <img
                            key={i}
                            src={`${API.BASE_URL}/uploads/${item.supplier_table}/${item.user_id}/${img}`}
                            alt="thumbnail"
                            className={`card-thumbnail ${
                              selectedImages[item.id] === img ||
                              (!selectedImages[item.id] && i === 0)
                                ? "active-thumb"
                                : ""
                            }`}
                            onClick={() => {
                              openImagePopup(
                                item.id,
                                img,
                                item.user_id,
                                item.images,
                                item.supplier_table,
                              );

                              setTimeout(() => {
                                thumbnailRefs.current[item.id]?.children[
                                  i
                                ]?.scrollIntoView({
                                  behavior: "smooth",
                                  inline: "center",
                                  block: "nearest",
                                });
                              }, 100);
                            }}
                          />
                        ))}
                      </div>
                    )}

                    <div className="machine-body">
                      <h4 className="machine-name">{item.name}</h4>

                      <div className="spec-row mt-2 mb-0">
                        <div className="spec-item">
                          <span className="spec-label">Mobile:</span>

                          <span className="spec-value text-dark fw-semibold">
                            {item.mobile}
                          </span>
                        </div>

                        <div className="spec-item">
                          <span className="spec-label">Email:</span>

                          <span>{item.email || ""}</span>
                        </div>
                      </div>

                      <div>
                        {/* <button
                          className="btn btn-link btn-sm p-0 text-decoration-none text-start text-secondary"
                          onClick={() => handleLocationRedirect(item.address)}
                        >
                          <i className="bi bi-geo-alt-fill text-danger me-1"></i>

                          <span
                            style={{
                              color: "#1a2daa",
                              fontWeight: "bold",
                            }}
                          >
                            {item.address}
                          </span>
                        </button> */}
                        {item.address && (
                          <p
                            className="bm_address"
                            onClick={() => {
                              if (item.maplink) {
                                window.open(
                                  item.maplink,
                                  "_blank",
                                  "noopener,noreferrer",
                                );
                              }
                            }}
                            style={{
                              cursor: item.maplink ? "pointer" : "default",
                              margin: "0px",
                            }}
                            title={item.maplink ? "Open in Google Maps" : ""}
                          >
                            <i className="bi bi-geo-alt-fill"></i>{" "}
                            {item.address}
                          </p>
                        )}
                      </div>
                    </div>
                  </div>
                ))}
              </div>

              {/* PAGINATION HERE */}

              {totalPages > 1 && (
                <div className="pagination-container d-flex justify-content-center mt-5">
                  <ul className="pagination">
                    <li
                      className={`page-item ${currentPage === 1 ? "disabled" : ""}`}
                    >
                      <button
                        className="page-link"
                        onClick={() => paginate(currentPage - 1)}
                      >
                        Previous
                      </button>
                    </li>

                    {[...Array(totalPages)].map((_, index) => (
                      <li
                        key={index}
                        className={`page-item ${
                          currentPage === index + 1 ? "active" : ""
                        }`}
                      >
                        <button
                          className="page-link"
                          onClick={() => paginate(index + 1)}
                        >
                          {index + 1}
                        </button>
                      </li>
                    ))}

                    <li
                      className={`page-item ${
                        currentPage === totalPages ? "disabled" : ""
                      }`}
                    >
                      <button
                        className="page-link"
                        onClick={() => paginate(currentPage + 1)}
                      >
                        Next
                      </button>
                    </li>
                  </ul>
                </div>
              )}
              <div className="mt-3">
                {" "}
                <HorizontalAds />
              </div>
            </>
          )}
        </div>

        {/* ==========================================================================
            RIGHT ADVERTISING SIDEBAR
           ========================================================================== */}
        {/* <div className="col-lg-2">
          <div
            className="ads-sidebar p-3 bg-white shadow-sm rounded text-center sticky-top"
            style={{ top: "20px" }}
          >
            <h5 className="ads-title">Sponsored</h5>

            <div className="ad-card mt-3 p-2 border rounded bg-light">
              <span
                className="badge bg-warning text-dark mb-2"
                style={{ fontSize: "10px" }}
              >
                PREMIUM
              </span>
              <h6>Embroidery Files</h6>
              <p className="small text-muted">
                Get instant access to top-tier .DST and .EMB design packs.
              </p>
              <button className="btn btn-xs btn-primary w-100 btn-sm">
                Explore Packs
              </button>
            </div>

            <div className="ad-card mt-4 p-2 border rounded">
              <span
                className="text-muted d-block small mb-1"
                style={{ fontSize: "11px" }}
              >
                Advertisement
              </span>
              <h6>StitchMart Logistics</h6>
              <p className="small text-muted">
                Reliable multi-bead devices listing tools inside your dashboard
                portal.
              </p>
              <a
                href="/machines"
                className="btn btn-link btn-sm text-decoration-none p-0 fw-bold"
                style={{ color: "#00a699" }}
              >
                View Equipment →
              </a>
            </div>
          </div>
        </div> */}
      </div>

      {/* Styled Components Sheet Overrides */}
      <style>{`
        .cursor-pointer { cursor: pointer; }
        .thumbnail-tray::-webkit-scrollbar { height: 4px; }
        .thumbnail-tray::-webkit-scrollbar-thumb { background: #ccc; border-radius: 4px; }
        .hover-underline:hover { text-decoration: underline !important; color: #00a699 !important; }
        .core-filter-label { font-size: 14px; color: #555; cursor: pointer; }
      `}</style>
      {popupData.open && (
        <div
          className="image-popup"
          onClick={() => setPopupData((p) => ({ ...p, open: false }))}
        >
          <div
            className="image-popup-content"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              className="popup-close"
              onClick={() => setPopupData((p) => ({ ...p, open: false }))}
            >
              ✕
            </button>
            {/* 
            <img
              src={`${API.BASE_URL}/uploads/${item.supplier_table}/user_${popupData.userId}/${popupData.images[popupData.index]}`}
              alt="Preview"
            /> */}
            <img
              src={`${API.BASE_URL}/uploads/${popupData.supplierTable}/${popupData.userId}/${popupData.images[popupData.index]}`}
              alt="Preview"
            />

            <button
              className="popup-nav left"
              onClick={() =>
                setPopupData((p) => ({
                  ...p,
                  index: Math.max(0, p.index - 1),
                }))
              }
            >
              <i className="bi bi-chevron-left"></i>
            </button>

            <button
              className="popup-nav right"
              onClick={() =>
                setPopupData((p) => ({
                  ...p,
                  index: Math.min(p.images.length - 1, p.index + 1),
                }))
              }
            >
              <i className="bi bi-chevron-right"></i>
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
